import { render, staticRenderFns } from "./ConfirmPhoneNumberForm.vue?vue&type=template&id=138e3490&scoped=true&lang=pug&"
import script from "./ConfirmPhoneNumberForm.vue?vue&type=script&lang=ts&"
export * from "./ConfirmPhoneNumberForm.vue?vue&type=script&lang=ts&"
import style0 from "./ConfirmPhoneNumberForm.vue?vue&type=style&index=0&id=138e3490&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138e3490",
  null
  
)

export default component.exports